import React, { useRef, useState } from 'react';
import _ from 'lodash';
import Slider, { Settings } from 'react-slick';
import styles from './ProductDetailsSlider.module.scss';
import { AssetEntity } from 'src/modules/assets';
import { ProductDetailsZoomSlider, isLandscapeAsset } from 'src/modules/products';
import { useIntl } from 'react-intl';
import { GlobalIcon, IconImage } from 'src/modules/global';
import { classes } from 'src/utils/styles';

interface ProductDetailsSliderProps {
  activeAsset: AssetEntity;
  assets: AssetEntity[];
  name: string;
  className?: string;
}

const ProductDetailsSlider: React.FunctionComponent<ProductDetailsSliderProps> = (props) => {
  const intl = useIntl();
  const { activeAsset: initialActiveAsset, assets, name, className } = props;

  const [activeAsset, setActiveAsset] = useState(initialActiveAsset);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeZoomSlider, setActiveZoomSlider] = useState(null);
  const [isBlocked, setIsBlocked] = useState(false);
  const hasMultipleAssets = _.size(props?.assets) > 1;

  const slider = useRef<Slider>();

  const speed = 500;

  const settings: Settings = {
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    // variableWidth: false,
    adaptiveHeight: false,
    afterChange: (newIndex: number) => {
      setActiveAsset(assets[newIndex]);
      setCurrentIndex(newIndex);
    },
    speed,
  };

  const unblock = () => {
    setIsBlocked(true);
    setTimeout(() => {
      setIsBlocked(false);
    }, speed);
  };

  const handleNext = () => {
    if (isBlocked) {
      return;
    }
    unblock();
    slider.current.slickNext();
  };
  const handlePrev = () => {
    if (isBlocked) {
      return;
    }
    unblock();
    slider.current.slickPrev();
  };

  const setSliderRef = (s) => {
    slider.current = s;

    if (s) {
      s.slickGoTo(currentIndex);
    }
  };

  return (
    <div className={className}>
      <div className={styles.wrapper}>
        <div className={styles.content} data-test="iconLeft">
          <div className={classes([styles.navButton, styles.LeftArrow, styles.iconContainer])} />
          <div
            className={classes([styles.navButton, styles.navButtonNext, styles.iconContainer])}
          />
          {hasMultipleAssets && (
            <>
              <GlobalIcon
                image={IconImage.LeftArrow}
                onClick={handlePrev}
                className={classes([styles.navButton, styles.navButtonPrev])}
                data-test="prevButton"
              />
              <GlobalIcon
                image={IconImage.RightArrow}
                onClick={handleNext}
                className={classes([styles.navButton, styles.navButtonNext])}
                data-test="nextButton"
              />
            </>
          )}
          <div
            className={classes([
              styles.sliderWrapper,
              isLandscapeAsset(assets) ? styles.landscape : styles.portrait,
            ])}>
            <Slider ref={setSliderRef} {...settings}>
              {assets.map((a, i) => (
                <div
                  key={a.id}
                  data-index={i}
                  className={classes([
                    styles.slideWrapper,
                    a.id === activeAsset.id ? styles.active : null,
                    styles.square,
                  ])}
                  // style={{ width }}
                >
                  <div className={classes([styles.content, styles.imageWrapper])}>
                    {a?.file && (
                      <img
                        src={a.file?.url}
                        alt={a.file?.alternativeText}
                        onClick={() => {
                          setActiveZoomSlider(a);
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </Slider>
            {hasMultipleAssets && (
              <div className={styles.imageCount}>{`${currentIndex + 1} ${intl.formatMessage({
                id: 'page/professionals/downloads/products/detail/slider_of',
              })} ${assets.length}`}</div>
            )}
          </div>
        </div>
      </div>
      {!!activeZoomSlider && (
        <ProductDetailsZoomSlider
          activeAsset={activeZoomSlider}
          assets={assets}
          caption={name}
          onClose={() => setActiveZoomSlider(null)}
          fullScreen={true}
          objectFit="contain"
        />
      )}
    </div>
  );
};

export default ProductDetailsSlider;
